import React from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { withViewport } from '../../util/contextHelpers';
import classNames from 'classnames';

import {
  Footer,
  LayoutSingleColumn,
  LayoutWrapperFooter,
  LayoutWrapperMain,
  LayoutWrapperTopbar,
  Page,
  Button,
  NamedLink,
  ExternalLink,
  IntegrateFreelancersBanner,
  ContactPreFooter,
} from '../../components';
import { TopbarContainer } from '..';
import { FormattedMessage } from '../../util/reactIntl';

import SolutionPageHeroSection from './SolutionPageHeroSection';
import SolutionPageProblemsSection from './SolutionPageProblemsSection';
import SolutionPageInfoSection from './SolutionPageInfoSection';
import OptionBanner from './OptionBanner';

import heroImage from '../../assets/digitalagency-freelancer-hero-image-horizontal.webp';
import infoImage from '../../assets/freelancer-image-solutions.webp';
import testimonialSectionImage from '../../assets/freelanceri-at-cafe.webp';
import miikkaImg from '../../assets/pro-miikka-salminen.webp';
import IntegrateFreelancersBannerImg from '../../assets/integrate-freelancers-banner-image.webp';

import css from './SolutionPages.css';

const DigitalAgencySolutionPageComponent = props => {
  const { intl, scrollingDisabled } = props;

  const schemaTitle = intl.formatMessage({ id: 'DigitalAgencySolutionPage.schemaTitle' });
  const schemaDescription = intl.formatMessage({
    id: 'DigitalAgencySolutionPage.schemaDescription',
  });

  const heroCaption = intl.formatMessage({
    id: 'DigitalAgencySolutionPage.heroCaption',
  });
  const heroTitle = intl.formatMessage({ id: 'DigitalAgencySolutionPage.heroTitle' });
  const heroSubtitle = intl.formatMessage({ id: 'DigitalAgencySolutionPage.heroSubtitle' });
  const heroButtonText = intl.formatMessage({ id: 'DigitalAgencySolutionPage.heroButtonText' });

  const problemsTitle = intl.formatMessage({ id: 'DigitalAgencySolutionPage.problemsTitle' });
  const problemsCardTitle1 = intl.formatMessage({
    id: 'DigitalAgencySolutionPage.problemsCardTitle1',
  });
  const problemsCardText1 = intl.formatMessage({
    id: 'DigitalAgencySolutionPage.problemsCardText1',
  });
  const problemsCardTitle2 = intl.formatMessage({
    id: 'DigitalAgencySolutionPage.problemsCardTitle2',
  });
  const problemsCardText2 = intl.formatMessage({
    id: 'DigitalAgencySolutionPage.problemsCardText2',
  });
  const problemsCardTitle3 = intl.formatMessage({
    id: 'DigitalAgencySolutionPage.problemsCardTitle3',
  });
  const problemsCardText3 = intl.formatMessage({
    id: 'DigitalAgencySolutionPage.problemsCardText3',
  });
  const problemsCardTitle4 = intl.formatMessage({
    id: 'DigitalAgencySolutionPage.problemsCardTitle4',
  });
  const problemsCardText4 = intl.formatMessage({
    id: 'DigitalAgencySolutionPage.problemsCardText4',
  });

  const infoTitle = intl.formatMessage({ id: 'DigitalAgencySolutionPage.infoTitle' });
  const infoImageName = intl.formatMessage({
    id: 'DigitalAgencySolutionPage.infoImageName',
  });
  const infoImageText1 = intl.formatMessage({
    id: 'DigitalAgencySolutionPage.infoImageText1',
  });
  const infoImageText2 = intl.formatMessage({
    id: 'DigitalAgencySolutionPage.infoImageText2',
  });
  const infoImageText3 = intl.formatMessage({
    id: 'DigitalAgencySolutionPage.infoImageText3',
  });
  const infoImageText4 = intl.formatMessage({
    id: 'DigitalAgencySolutionPage.infoImageText4',
  });
  const infoCardTitle1 = intl.formatMessage({
    id: 'DigitalAgencySolutionPage.infoCardTitle1',
  });
  const infoCardSubtitle1 = intl.formatMessage({
    id: 'DigitalAgencySolutionPage.infoCardSubtitle1',
  });
  const infoCardText11 = intl.formatMessage({
    id: 'DigitalAgencySolutionPage.infoCardText11',
  });
  const infoCardText12 = intl.formatMessage({
    id: 'DigitalAgencySolutionPage.infoCardText12',
  });
  const infoCardTitle2 = intl.formatMessage({
    id: 'DigitalAgencySolutionPage.infoCardTitle2',
  });
  const infoCardSubtitle2 = intl.formatMessage({
    id: 'DigitalAgencySolutionPage.infoCardSubtitle2',
  });
  const infoCardText2 = intl.formatMessage({
    id: 'DigitalAgencySolutionPage.infoCardText2',
  });
  const handleShowSpaceHome = () => {
    if (typeof window === 'object') {
      window.Intercom('showSpace', 'home');
    }
  };

  const optionProBannerFooter = (
    <div className={css.optionProFooter}>
      <Button className={css.contactButton} onClick={handleShowSpaceHome}>
        <FormattedMessage id="StartBuyingInfoPage.contactButton" />
      </Button>
      <NamedLink name="ProLandingPage">
        <FormattedMessage id="StartBuyingInfoPage.proLandingPageLink" />
      </NamedLink>
    </div>
  );

  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      description={schemaDescription}
      title={schemaTitle}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: schemaDescription,
        name: schemaTitle,
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="DigitalAgencySolutionPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <div className={css.sections}>
            <SolutionPageHeroSection
              heroCaption={heroCaption}
              title={heroTitle}
              subTitle={heroSubtitle}
              buttonText={heroButtonText}
              imgSrc={heroImage}
              handleShowSpaceHome={handleShowSpaceHome}
            />
            <SolutionPageProblemsSection
              title={problemsTitle}
              cardTitle1={problemsCardTitle1}
              cardText1={problemsCardText1}
              cardTitle2={problemsCardTitle2}
              cardText2={problemsCardText2}
              cardTitle3={problemsCardTitle3}
              cardText3={problemsCardText3}
              cardTitle4={problemsCardTitle4}
              cardText4={problemsCardText4}
            />
            <SolutionPageInfoSection
              title={infoTitle}
              imageName={infoImageName}
              imageText1={infoImageText1}
              imageText2={infoImageText2}
              imageText3={infoImageText3}
              imageText4={infoImageText4}
              cardTitle1={infoCardTitle1}
              cardSubtitle1={infoCardSubtitle1}
              cardText11={infoCardText11}
              cardText12={infoCardText12}
              cardTitle2={infoCardTitle2}
              cardSubtitle2={infoCardSubtitle2}
              cardText2={infoCardText2}
              imgSrc={infoImage}
            />
            <IntegrateFreelancersBanner
              imgSrc={IntegrateFreelancersBannerImg}
              titleId="DigitalAgencySolutionPage.integrateFreelancersBannerTitle"
              textId="DigitalAgencySolutionPage.integrateFreelancersBannerText"
            />
            <OptionBanner
              rootClass={classNames(css.optionBannerRoot)}
              optionLabelId="DigitalAgencySolutionPage.optionBannerLabel"
              titleId="DigitalAgencySolutionPage.optionBannerTitle"
              titleDescriptionId="DigitalAgencySolutionPage.optionBannerDescription"
              step1TitleId="DigitalAgencySolutionPage.optionBannerStep1Title"
              step2TitleId="DigitalAgencySolutionPage.optionBannerStep2Title"
              step3TitleId="DigitalAgencySolutionPage.optionBannerStep3Title"
              step1DescriptionId="DigitalAgencySolutionPage.optionBannerStep1Description"
              step2DescriptionId="DigitalAgencySolutionPage.optionBannerStep2Description"
              step3DescriptionId="DigitalAgencySolutionPage.optionBannerStep3Description"
              footerElement={optionProBannerFooter}
            />
            <div className={css.testimonialSection}>
              <div className={css.testimonialSectionTitle}>
                <FormattedMessage id="DigitalAgencySolutionPage.testimonialSectionTitle" />
              </div>
              <div className={css.testimonialSectionContent}>
                <div className={css.testimonialSectionContentText}>
                  <div className={css.testimonialSectionListItem}>
                    <div className={css.testimonialSectionListItemText}>
                      <FormattedMessage id="DigitalAgencySolutionPage.testimonialSectionText1" />
                    </div>
                    <div className={css.testimonialSectionListItemUser}>
                      <FormattedMessage id="ProLandingPage.proTestimonialSectionUser1" />
                    </div>
                  </div>
                  <div className={css.testimonialSectionListItem}>
                    <div className={css.testimonialSectionListItemText}>
                      <FormattedMessage id="DigitalAgencySolutionPage.testimonialSectionText2" />
                    </div>
                    <div className={css.testimonialSectionListItemUser}>
                      <FormattedMessage id="ProLandingPage.proTestimonialSectionUser2" />
                    </div>
                  </div>
                </div>
                <div className={css.testimonialSectionImageContainer}>
                  <img
                    src={testimonialSectionImage}
                    alt="Testimonial Section"
                    className={css.testimonialSectionContentImage}
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
          <ContactPreFooter />
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

const { number, shape } = PropTypes;

DigitalAgencySolutionPageComponent.propTypes = {
  // form withViewport
  viewport: shape({
    width: number.isRequired,
    height: number.isRequired,
  }).isRequired,

  // from injectIntl
  intl: intlShape.isRequired, // from injectIntl
};

const mapStateToProps = state => {
  const { currentUser } = state.user;

  return {
    scrollingDisabled: isScrollingDisabled(state),
    currentUser,
  };
};

const DigitalAgencySolutionPage = compose(
  withRouter,
  connect(mapStateToProps),
  withViewport,
  injectIntl
)(DigitalAgencySolutionPageComponent);

export default DigitalAgencySolutionPage;
